module.exports = __webpack_public_path__ + "static/media/ss5.0bd8df53.png";